import { Store, UndoManager } from '@sama/app-state';
import { UndoRedoService } from '../../team-apis/content/undo-redo-service';

export abstract class AbstractUndoManager<StateType, UndoStateType>
  extends UndoManager<StateType, UndoStateType>
  implements UndoRedoService
{
  constructor(store: Store<StateType>) {
    // 1000 max depth is not carefully thought out - just "plenty big"
    super(store, 1000);
  }

  override pushCurrentState(options?: {
    collectKey?: string;
    collectDebounce?: number;
  }) {
    const stateBefore = this.currentUndoState;
    super.pushCurrentState(options);
    return {
      hasTrackedChanges: this.hasTrackedChanges(
        stateBefore,
        this.currentUndoState,
      ),
    };
  }

  protected abstract hasTrackedChanges(
    // before state is undefined the first time
    before: UndoStateType | undefined,
    after: UndoStateType,
  ): boolean;
}
